import React, { useState } from "react";
import { Keyboard } from "lucide-react";
import { validateSecretCode, activateFeature } from "../../utils/secretCodes";

const DeveloperCode = () => {
  const [code, setCode] = useState("");
  const [message, setMessage] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    handleCodeCheck(code);
  };

  const handleCodeCheck = (submittedCode) => {
    // 1) Validate the exact code string (case-sensitive if your dictionary is case-sensitive).
    const secretResult = validateSecretCode(submittedCode);

    if (secretResult) {
      // 2) Activate the feature (writes to localStorage, etc.)
      activateFeature(secretResult.feature);

      // 3) Show the correct success message based on the feature or use the provided description.
      setMessage({
        type: "success",
        text:
          secretResult.feature === "RESET_THEMES"
            ? "🔄 Themes have been reset to default!"
            : secretResult.description,
      });
    } else {
      // If we got null, the code was invalid or didn’t match exactly
      setMessage({
        type: "error",
        text: "Invalid developer code",
      });
    }

    // Clear the input field
    setCode("");

    // Clear message after 3 seconds
    setTimeout(() => {
      setMessage(null);
    }, 3000);
  };

  return (
    <div className="settings-section">
      <h2>Developer Code</h2>
      <div className="settings-content">
        <div className="developer-code-container">
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Enter developer code..."
              className="developer-code-input"
            />
            <button type="submit" className="developer-code-button">
              <Keyboard size={16} />
              Submit Code
            </button>
          </form>
          {message && (
            <div className={`developer-code-message ${message.type}`}>
              {message.text}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeveloperCode;
